import { render, staticRenderFns } from "./register.vue?vue&type=template&id=336cd038&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CFormLabel: require('@chakra-ui/vue').CFormLabel, CText: require('@chakra-ui/vue').CText, CInput: require('@chakra-ui/vue').CInput, CIcon: require('@chakra-ui/vue').CIcon, CInputRightElement: require('@chakra-ui/vue').CInputRightElement, CInputGroup: require('@chakra-ui/vue').CInputGroup, CFormControl: require('@chakra-ui/vue').CFormControl, CSelect: require('@chakra-ui/vue').CSelect, CFormHelperText: require('@chakra-ui/vue').CFormHelperText, CButton: require('@chakra-ui/vue').CButton, CLink: require('@chakra-ui/vue').CLink, CBox: require('@chakra-ui/vue').CBox})
